import cc from 'classcat';
import { useRef, useId } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useStrokeWidth } from './hooks/useStrokeWidth.js';
import { svgCls } from './styles/svg.js';

const PATH = "M222 0C99.4 0 0 99.4 0 222c0 58.9 23.4 115.3 65 157 86.7 86.7 227.3 86.7 314 0s86.7-227.3 0-314C337.4 23.3 280.9-.2 222 0z";
const CircleOutlinedShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  const internalRef = useRef(null);
  const ref = shapeRef ?? internalRef;
  const iconId = useId();
  const clipPathId = `circle-outlined-${iconId.replace(/[^a-z0-9]/gi, "-")}`;

  // double stroke width and use clip-path to mimic an inside stroke, which is
  // what we're technically aiming for
  const strokeWidth = 2 * useStrokeWidth(ref, 15, {
    width: 400,
    height: 400
  });
  return /*#__PURE__*/jsxs("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 444 444",
    stroke: fillColor,
    children: [/*#__PURE__*/jsx("clipPath", {
      id: clipPathId,
      children: /*#__PURE__*/jsx("path", {
        d: PATH
      })
    }), /*#__PURE__*/jsx("path", {
      d: PATH,
      fill: "none",
      clipPath: `url(#${clipPathId})`,
      vectorEffect: "non-scaling-stroke",
      strokeWidth: strokeWidth,
      strokeMiterlimit: strokeWidth
    })]
  });
};

export { CircleOutlinedShape };
//# sourceMappingURL=CircleOutlinedShape.js.map
